import AxiosInstance from './AxiosInstance.js';

class AuthError {
  constructor(message) {
    this.name = 'AuthError';
    this.stack = new Error(message).stack;
    this.message = message;
  }
}

export function checkUser() {
  return AxiosInstance.get('/api/signcheck').then((res) => {
    if (res.status !== 204 && res.data) return res.data;
    else return null;
  });
}

export function signIn(email, password) {
  return AxiosInstance.post('/api/signin', { email, password }).catch((err) => {
    if (err.response && err.response.status === 401) {
      throw new AuthError();
    } else throw err;
  });
}

export function signUp(body) {
  return AxiosInstance.post('/api/signup', body).catch((err) => {
    if (
      err.response.data.errors &&
      err.response.data.errors.find((element) => element.param === 'email')
    ) {
      throw new AuthError('Este email já está em uso.');
    } else throw err;
  });
}

export function signOut() {
  return AxiosInstance.post('/api/signout');
}

export function forgotPassword(email) {
  return AxiosInstance.post('/api/password/forgot', { email });
}

export function resetPassword(userId, token, body) {
  return AxiosInstance.post(`/api/password/reset/${token}/${userId}`, body);
}
